import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import LoginForm from "../../forms/auth/AuthPage";
import {login} from "../../../actions/auth";
import application from "../../../data/application.json";

import {Link} from "react-router-dom";

class LoginPage extends React.Component {
    submit = data =>
        this.props.login(data).then(() => this.props.history.push("/entity/register"));

    render() {
        return (
            <div className="container">
                    <div className="row mb-2 mt-3">
                            <div className="col-12 text-center">
                                <h1>{application.company}</h1>
                                <h2>{application.name}</h2>
                                <h3>Login</h3>
                            </div>
                    </div>
                    <div className="row mt-5">
                        <div className="col-12 offset-sm-2 col-sm-8 offset-md-3 col-md-6 mt-2">
                            <LoginForm submit={this.submit}/>
                        </div>
                    </div>
            </div>
        );
    }
}

LoginPage.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func.isRequired
    }).isRequired,
    login: PropTypes.func.isRequired
};

export default connect(null, {login})(LoginPage);



// WEBPACK FOOTER //
// ./src/components/pages/auth/AuthPage.js